import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "antd/dist/reset.css";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { VictimsAndKillersProvider } from "./providers/VictimsAndKillersProvider";
import { LoadingProvider } from "./providers/LoadingProvider";
import { ConfirmModalProvider } from "./providers/ConfirmModalProvider";
import { ErrorModalProvider } from "./providers/ErrorModalProvider";
import { CustomMarkersProvider } from "./providers/CustomMarkersProvider";
import { HighlightProvider } from "./providers/HighlightProvider";
import { NotesAndPicturesProvider } from "./providers/NotesAndPicturesProvider";
import LoadingSpinner from "./components/ui/LoadingSpinner";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ErrorModalProvider>
        <LoadingProvider>
          <ConfirmModalProvider>
            <VictimsAndKillersProvider>
              <CustomMarkersProvider>
                <HighlightProvider>
                  <NotesAndPicturesProvider>
                    <App />
                    <LoadingSpinner />
                  </NotesAndPicturesProvider>
                </HighlightProvider>
              </CustomMarkersProvider>
            </VictimsAndKillersProvider>
          </ConfirmModalProvider>
        </LoadingProvider>
      </ErrorModalProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);

reportWebVitals();
